import type { FC } from 'react';
import { useCallback, useContext, useState } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import LicenseForm from '@wix/da-submit-shared/pkg/common/LicenseForm';
import DesktopBatchActionWrapper from '../DesktopBatchActionWrapper';
import MobileBatchActionWrapper from '../MobileBatchActionWrapper';
import { BatchEditLicense } from '../../../types/batchActions';
import { BatchActionProps } from '../types';

import s from './LicenseBatchEdit.scss';

export interface Props extends BatchActionProps {
  batchEditLicense: (license: BatchEditLicense) => void;
}

const LicenseBatchEdit: FC<Props> = ({
  batchEditLicense,
  selectionArea,
}) => {
  const isMobile = useContext(MobileContext);
  const [value, setValue] = useState<BatchEditLicense | undefined>({
    cc: false,
    attr: false,
    deriv: 'no',
  });
  const handleSave = useCallback(() => {
    value && batchEditLicense(value);
  }, [value, batchEditLicense]);
  const form = (
    <div className={s['root']}>
      <LicenseForm currentValue={value} setValue={setValue} />
    </div>
  );

  if (isMobile) {
    return (
      <MobileBatchActionWrapper
        onSave={handleSave}
        restrictSave="non_core_multiple"
      >
        {form}
      </MobileBatchActionWrapper>
    );
  }

  return (
    <DesktopBatchActionWrapper
      selectionArea={selectionArea}
      onSave={handleSave}
      restrictSave="non_core_multiple"
    >
      {form}
    </DesktopBatchActionWrapper>
  );
};
LicenseBatchEdit.displayName = 'LicenseBatchEdit';

export default LicenseBatchEdit;
